// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__2Mvml","filesListContainer":"PosDisputesFiles_filesListContainer__2owYx","filesButton":"PosDisputesFiles_filesButton__1GRNs"};